import apiClient from "./apiClient";
import { ENDPOINTS } from "./config";
import { Course } from "../../types/course";

// Types
export interface CourseFilter {
  level?: string;
  universityId?: string;
  studyMode?: string;
  language?: string;
  search?: string;
  minFee?: number;
  maxFee?: number;
  page?: number;
  limit?: number;
  [key: string]: string | number | boolean | undefined;
}

export interface Pagination {
  page: number;
  limit: number;
  total: number;
  totalPages: number;
  hasNext: boolean;
  hasPrev: boolean;
}

export interface FilterOptions {
  levels: Array<{ level: string; count: number }>;
  studyModes: Array<{ studyMode: string; count: number }>;
  universities: Array<{ id: string; name: string; count: number }>;
  countries: Array<{ country: string; count: number }>;
  feeRange: { min: number; max: number };
}

export interface CoursesResponse {
  success: boolean;
  message: string;
  data: Course[];
  pagination: Pagination;
  filters: FilterOptions;
}

/**
 * CourseService for handling course/program-related API calls
 */
class CourseService {
  /**
   * Get popular courses
   */
  public async getPopularCourses() {
    return apiClient.get<{ success: boolean; message: string; data: Course[] }>(
      ENDPOINTS.COURSES.POPULAR_COURSES
    );
  }

  /**
   * Get all courses with filtering, pagination, and search
   */
  public async getAllCourses(filters?: CourseFilter) {
    return apiClient.get<CoursesResponse>(
      ENDPOINTS.COURSES.GET_ALL_COURSES,
      filters
    );
  }

  /**
   * Get course details by ID
   */
  public async getCourseDetails(id: string) {
    return apiClient.get<{
      success: boolean;
      message: string;
      data: {
        course: Course;
        relatedCourses: Course[];
      };
    }>(ENDPOINTS.COURSES.DETAILS(id));
  }

  /**
   * Filter courses
   */
  public async filterCourses(filters: CourseFilter) {
    return apiClient.get<CoursesResponse>(
      ENDPOINTS.COURSES.GET_ALL_COURSES,
      filters
    );
  }
}

export const courseService = new CourseService();

export default courseService;
